import React from 'react';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './mentorAvailabilityStatusBeacon.css';

const MentorAvailabilityStatusBeacon = ({availabilityStatus = null}) => {
  return (
    <div
      className={`et-mentor-availability-status-beacon-container ${
        availabilityStatus === VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE
          ? 'et-masbc-available'
          : availabilityStatus === VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
            ? 'et-masbc-busy'
            : 'et-masbc-offline'
      }`}
    />
  );
};

export default MentorAvailabilityStatusBeacon;
